/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "./request";
const mockUrl_0_0_0_0 = "http://yapi.yishou.com/mock/128";
const devUrl_0_0_0_0 = "http://erp38.yishou.com/";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 [次品盘点日志列表\/导出↗](http://yapi.yishou.com/project/128/interface/api/34771) 的 **请求配置**
 *
 * @分类 [次品盘点↗](http://yapi.yishou.com/project/128/interface/api/cat_3634)
 * @请求头 `POST /erp/InventoryDp/dpInventoryLog`
 */
const dpInventoryLogRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/InventoryDp/dpInventoryLog",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["create_time", "is_excel", "inventory_dp_no", "dbid", "sku", "is_moved", "page", "page_size"],
        properties: {
            create_time: { type: "string", description: "盘点时间Y-m-d H:i:s" },
            is_excel: { type: "string", description: "存在此参则导出" },
            inventory_dp_no: { type: "string", description: "盘点单号" },
            dbid: { type: "string", description: "打标id" },
            sku: { type: "string", description: "sku" },
            is_moved: { type: "string", description: "是否移动:{1:是,2:否}" },
            page: { type: "string", description: "1" },
            page_size: { type: "string", description: "20" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            count: { type: "number", description: "数据总个数" },
            file: { type: "string", description: "导出文件链接" },
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        dbid: { type: "string", description: "打标ID" },
                        sku: { type: "string", description: "SKU" },
                        inventory_dp_no: { type: "string", description: "盘点单号" },
                        inventory_area_type: { type: "string", description: "盘点仓区" },
                        inventory_type: { type: "string", description: "盘点类型" },
                        inventory_model: { type: "string", description: "盘点方式" },
                        created_at: { type: "string", description: "盘点时间" },
                        create_admin: { type: "string", description: "--暂时无用" },
                        inventory_times: { type: "string", description: "--暂时无用" },
                        inventory_package_no: { type: "string", description: "盘点包裹号" },
                        source_inventory_package_no: { type: "string", description: "原盘点包裹号" },
                        is_moved: { type: "string", description: "--暂时无用" },
                        goods_no: { type: "string", description: "--暂时无用" },
                        co_val: { type: "string", description: "颜色" },
                        si_val: { type: "string", description: "尺码" },
                        goods_name: { type: "string", description: "商品名" },
                        create_name: { type: "string", description: "盘点时间" },
                        inventory_times_str: { type: "string", description: "盘点次数" },
                        is_moved_str: { type: "string", description: "是否移动" },
                        stock_detail_sj_status_str: { type: "string", description: "上架状态" },
                    },
                },
                description: "数据列表",
            },
        },
        required: ["file"],
    },
    requestFunctionName: "dpInventoryLog",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [次品盘点日志列表\/导出↗](http://yapi.yishou.com/project/128/interface/api/34771) 的 **请求函数**
 *
 * @分类 [次品盘点↗](http://yapi.yishou.com/project/128/interface/api/cat_3634)
 * @请求头 `POST /erp/InventoryDp/dpInventoryLog`
 */
export const dpInventoryLog = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(dpInventoryLogRequestConfig, requestData), ...args);
};
dpInventoryLog.requestConfig = dpInventoryLogRequestConfig;
/**
 * 接口 [次品盘点包裹导入↗](http://yapi.yishou.com/project/128/interface/api/34780) 的 **请求配置**
 *
 * @分类 [次品盘点↗](http://yapi.yishou.com/project/128/interface/api/cat_3634)
 * @请求头 `POST /erp/InventoryDp/importDpWithPackage`
 */
const importDpWithPackageRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/InventoryDp/importDpWithPackage",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["file", "origin_id"],
        properties: {
            file: { type: "file", description: "导入文件", tsType: "FileData" },
            origin_id: { type: "string", description: "仓库id" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            result: { type: "boolean", description: "导入结果" },
            msg: { type: "string" },
            file: { type: "array", items: { type: "string" }, description: "导入失败返回文件链接" },
            errorListMsg: { type: "array", items: { type: "string" }, description: "--暂时无用" },
        },
    },
    requestFunctionName: "importDpWithPackage",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [次品盘点包裹导入↗](http://yapi.yishou.com/project/128/interface/api/34780) 的 **请求函数**
 *
 * @分类 [次品盘点↗](http://yapi.yishou.com/project/128/interface/api/cat_3634)
 * @请求头 `POST /erp/InventoryDp/importDpWithPackage`
 */
export const importDpWithPackage = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(importDpWithPackageRequestConfig, requestData), ...args);
};
importDpWithPackage.requestConfig = importDpWithPackageRequestConfig;
/**
 * 接口 [次品盘点单列表↗](http://yapi.yishou.com/project/128/interface/api/34834) 的 **请求配置**
 *
 * @分类 [次品盘点↗](http://yapi.yishou.com/project/128/interface/api/cat_3634)
 * @请求头 `POST /erp/InventoryDp/getInventoryDpList`
 */
const getInventoryDpListRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/InventoryDp/getInventoryDpList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: [
            "inventoryDpNo",
            "inventoryStatus",
            "inventoryTimes",
            "createStartTime",
            "createEndTime",
            "beginStartTime",
            "beginEndTime",
            "endStartTime",
            "endEndTime",
            "page",
            "pageSize",
            "isExcel",
        ],
        properties: {
            inventoryDpNo: { type: "string", description: "盘点单号" },
            inventoryStatus: {
                type: "string",
                description: "盘点状态:{0=全部, 1:待盘点,2:一盘进行中,3:一盘已完成,7:待终盘,8:终盘进行中,9:终盘已完成,10:盘点已结束,11:已作废}",
            },
            inventoryTimes: { type: "string", description: "盘点次数:{0:全部, 1:初盘,9:终盘}" },
            createStartTime: { type: "string", description: "创建开始时间" },
            createEndTime: { type: "string", description: "创建结束时间" },
            beginStartTime: { type: "string", description: "开始时间" },
            beginEndTime: { type: "string", description: "结束时间" },
            endStartTime: { type: "string", description: "开始时间" },
            endEndTime: { type: "string", description: "结束时间" },
            page: { type: "string", description: "页码" },
            pageSize: { type: "string", description: "每页大小" },
            isExcel: { type: "string", description: "是否导出 ：1=是 0=否" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        inventoryDpEntity: {
                            type: "object",
                            properties: {
                                id: { type: "string", description: '"8"' },
                                inventory_dp_no: { type: "string", description: '"PDD202212140008"' },
                                stock_storehouse_id: { type: "string", description: '"1"' },
                                inventory_times: { type: "string", description: '"1"' },
                                create_admin: { type: "string", description: '"刘飞鸿"' },
                                created_at: { type: "string", description: '"2022-12-14 16:51:47"' },
                                updated_at: { type: "string", description: '"2022-12-14 16:51:47"' },
                                begin_time: { type: "string", description: '"0"' },
                                end_time: { type: "string", description: '"0"' },
                                inventory_status: { type: "string", description: '"1"' },
                                inventory_progress: { type: "string", description: '"0"' },
                                should_count: { type: "string", description: '"5"' },
                                inventory_num: { type: "string", description: '"0"' },
                                stock_inventory_rate: { type: "string" },
                                remark: { type: "string" },
                                inventory_area_formal: { type: "string", description: '"次品区"' },
                                inventory_type_formal: { type: "string", description: '"全盘"' },
                                inventory_mode_formal: { type: "string", description: '"明盘"' },
                                inventory_times_formal: { type: "string", description: '"初盘"' },
                                begin_time_formal: { type: "string" },
                                end_time_formal: { type: "string" },
                                inventory_status_formal: { type: "string", description: '"待盘点"' },
                                packageListStr: { type: "string", description: '"DP123,DP124"' },
                                packageList: {
                                    type: "array",
                                    items: { type: "string", description: '"DP123"' },
                                    description: '["DP123","DP124"]',
                                },
                            },
                            additionalProperties: false,
                        },
                        packageList: { type: "string", description: '"DP123,DP124"' },
                    },
                    additionalProperties: false,
                },
                description: '[{"inventoryDpEntity":{"id":"8","inventory_dp_no":"PDD202212140008","stock_storehouse_id":"1","inventory_times":"1","create_admin":"刘飞鸿","created_at":"2022-12-14 16:51:47","updated_at":"2022-12-14 16:51:47","begin_time":"0","end_time":"0","inventory_status":"1","inventory_progress":"0","should_count":"5","inventory_num":"0","stock_inventory_rate":"","remark":"","inventory_area_formal":"次品区","inventory_type_formal":"全盘","inventory_mode_formal":"明盘","inventory_times_formal":"初盘","begin_time_formal":"","end_time_formal":"","inventory_status_formal":"待盘点","packageListStr":"DP123,DP124","packageList":["DP123","DP124"]},"packageList":"DP123,DP124"}]',
            },
            total: { type: "integer", description: "1" },
        },
        additionalProperties: false,
    },
    requestFunctionName: "getInventoryDpList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [次品盘点单列表↗](http://yapi.yishou.com/project/128/interface/api/34834) 的 **请求函数**
 *
 * @分类 [次品盘点↗](http://yapi.yishou.com/project/128/interface/api/cat_3634)
 * @请求头 `POST /erp/InventoryDp/getInventoryDpList`
 */
export const getInventoryDpList = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getInventoryDpListRequestConfig, requestData), ...args);
};
getInventoryDpList.requestConfig = getInventoryDpListRequestConfig;
/**
 * 接口 [获取当前可用的包裹号↗](http://yapi.yishou.com/project/128/interface/api/34843) 的 **请求配置**
 *
 * @分类 [次品盘点↗](http://yapi.yishou.com/project/128/interface/api/cat_3634)
 * @请求头 `POST /erp/InventoryDp/getCanUseDpPackageList`
 */
const getCanUseDpPackageListRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/InventoryDp/getCanUseDpPackageList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: { type: "object", required: [], properties: {} },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            packageList: { type: "array", items: { type: "string", description: '"A102"' }, description: '["A102","A101"]' },
        },
        additionalProperties: false,
    },
    requestFunctionName: "getCanUseDpPackageList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取当前可用的包裹号↗](http://yapi.yishou.com/project/128/interface/api/34843) 的 **请求函数**
 *
 * @分类 [次品盘点↗](http://yapi.yishou.com/project/128/interface/api/cat_3634)
 * @请求头 `POST /erp/InventoryDp/getCanUseDpPackageList`
 */
export const getCanUseDpPackageList = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getCanUseDpPackageListRequestConfig, requestData), ...args);
};
getCanUseDpPackageList.requestConfig = getCanUseDpPackageListRequestConfig;
/**
 * 接口 [创建次品盘点单↗](http://yapi.yishou.com/project/128/interface/api/34852) 的 **请求配置**
 *
 * @分类 [次品盘点↗](http://yapi.yishou.com/project/128/interface/api/cat_3634)
 * @请求头 `POST /erp/InventoryDp/createInventoryDp`
 */
const createInventoryDpRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/InventoryDp/createInventoryDp",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["packageNoList", "remark"],
        properties: {
            packageNoList: { type: "string", description: "次品包裹号,多个逗号隔开" },
            remark: { type: "string", description: "备注" },
        },
    },
    responseDataJsonSchema: { type: "object" },
    requestFunctionName: "createInventoryDp",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [创建次品盘点单↗](http://yapi.yishou.com/project/128/interface/api/34852) 的 **请求函数**
 *
 * @分类 [次品盘点↗](http://yapi.yishou.com/project/128/interface/api/cat_3634)
 * @请求头 `POST /erp/InventoryDp/createInventoryDp`
 */
export const createInventoryDp = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(createInventoryDpRequestConfig, requestData), ...args);
};
createInventoryDp.requestConfig = createInventoryDpRequestConfig;
/**
 * 接口 [废除盘点单↗](http://yapi.yishou.com/project/128/interface/api/34861) 的 **请求配置**
 *
 * @分类 [次品盘点↗](http://yapi.yishou.com/project/128/interface/api/cat_3634)
 * @请求头 `POST /erp/InventoryDp/setInvoiceDpAbolish`
 */
const setInvoiceDpAbolishRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/InventoryDp/setInvoiceDpAbolish",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["inventoryDpId"],
        properties: { inventoryDpId: { type: "string", description: "盘点单id" } },
    },
    responseDataJsonSchema: { type: "object" },
    requestFunctionName: "setInvoiceDpAbolish",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [废除盘点单↗](http://yapi.yishou.com/project/128/interface/api/34861) 的 **请求函数**
 *
 * @分类 [次品盘点↗](http://yapi.yishou.com/project/128/interface/api/cat_3634)
 * @请求头 `POST /erp/InventoryDp/setInvoiceDpAbolish`
 */
export const setInvoiceDpAbolish = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(setInvoiceDpAbolishRequestConfig, requestData), ...args);
};
setInvoiceDpAbolish.requestConfig = setInvoiceDpAbolishRequestConfig;
/**
 * 接口 [获取盘点单详情↗](http://yapi.yishou.com/project/128/interface/api/34870) 的 **请求配置**
 *
 * @分类 [次品盘点↗](http://yapi.yishou.com/project/128/interface/api/cat_3634)
 * @请求头 `POST /erp/InventoryDp/getInventoryDpDetail`
 */
const getInventoryDpDetailRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/InventoryDp/getInventoryDpDetail",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: [
            "inventoryDpId",
            "dbid",
            "dpPackage",
            "inventoryTimes",
            "isDiff",
            "isChayi",
            "inventoryStatus",
            "isExcel",
            "page",
            "pageSize",
        ],
        properties: {
            inventoryDpId: { type: "string", description: "盘点单id" },
            dbid: { type: "string", description: "打标Id" },
            dpPackage: { type: "string", description: "所属包裹号" },
            inventoryTimes: { type: "string", description: "盘点次数:{0:全部, 1:初盘,9:终盘}" },
            isDiff: { type: "string", description: "是否异常:{0:全部 , 1=是 , 2=否}" },
            isChayi: { type: "string", description: "最近两次盘点是否异常:{0:全部 , 1:是,2:否}" },
            inventoryStatus: { type: "string", description: "盘点状态:{0=全部 ,1=已盘点,2=未盘点}" },
            isExcel: { type: "string", description: "是否导出：{1=是 0=否}" },
            page: { type: "string", description: "1" },
            pageSize: { type: "string", description: "20" },
        },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            inventoryDpEntity: {
                type: "object",
                properties: {
                    id: { type: "string", description: '"5"' },
                    inventory_dp_no: { type: "string", description: '"PDD202212140005"' },
                    stock_storehouse_id: { type: "string", description: '"1"' },
                    inventory_times: { type: "string", description: '"1"' },
                    create_admin: { type: "string", description: '"刘飞鸿"' },
                    created_at: { type: "string", description: '"2022-12-14 16:45:39"' },
                    updated_at: { type: "string", description: '"2022-12-14 16:46:18"' },
                    begin_time: { type: "string", description: '"0"' },
                    end_time: { type: "string", description: '"1671007578"' },
                    inventory_status: { type: "string", description: '"10"' },
                    inventory_progress: { type: "string", description: '"0%"' },
                    should_count: { type: "string", description: '"5"' },
                    inventory_num: { type: "string", description: '"0"' },
                    stock_inventory_rate: { type: "string", description: '"0%"' },
                    remark: { type: "string" },
                    inventory_area_formal: { type: "string", description: '"次品区"' },
                    inventory_type_formal: { type: "string", description: '"全盘"' },
                    inventory_mode_formal: { type: "string", description: '"明盘"' },
                    inventory_times_formal: { type: "string", description: '"初盘"' },
                    begin_time_formal: { type: "string" },
                    end_time_formal: { type: "string", description: '"2022-12-14 16:46:18"' },
                    inventory_status_formal: { type: "string", description: '"盘点已结束"' },
                    packageListStr: { type: "string", description: '"DP123,DP124"' },
                    packageList: {
                        type: "array",
                        items: { type: "string", description: '"DP123"' },
                        description: '["DP123","DP124"]',
                    },
                },
                additionalProperties: false,
            },
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        id: { type: "string", description: '"18"' },
                        inventory_dp_id: { type: "string", description: '"5"' },
                        dp_package_no: { type: "string", description: '"DP123"' },
                        inventory_no: { type: "string" },
                        dbid: { type: "string", description: '"20102635"' },
                        first_inventory_stock_num: { type: "string", description: '"0"' },
                        first_inventory_admin: { type: "string" },
                        first_inventory_num: { type: "string", description: '"0"' },
                        first_inventory_diff_num: { type: "string" },
                        end_inventory_stock_num: { type: "string" },
                        end_inventory_admin: { type: "string" },
                        end_inventory_num: { type: "string" },
                        end_inventory_diff_num: { type: "string" },
                        inventory_admin_id: { type: "string", description: '"0"' },
                        diff_num: { type: "string", description: '"0"' },
                        is_chayi: { type: "string", description: '"0"' },
                        inventory_status: { type: "string", description: '"2"' },
                        inventory_times: { type: "string", description: '"1"' },
                        created_at: { type: "string", description: '"2022-12-14 16:45:39"' },
                        updated_at: { type: "string", description: '"2022-12-14 16:45:39"' },
                        co_val: { type: "string", description: '"灰色"' },
                        si_val: { type: "string", description: '"L"' },
                        is_diff_formal: { type: "string", description: '"否"' },
                        is_chayi_formal: { type: "string" },
                        inventory_status_formal: { type: "string", description: '"未盘点"' },
                        inventory_times_formal: { type: "string", description: '"初盘"' },
                    },
                    additionalProperties: false,
                },
                description: '[{"id":"18","inventory_dp_id":"5","dp_package_no":"DP123","inventory_no":"","dbid":"20102635","first_inventory_stock_num":"0","first_inventory_admin":"","first_inventory_num":"0","first_inventory_diff_num":"","end_inventory_stock_num":"","end_inventory_admin":"","end_inventory_num":"","end_inventory_diff_num":"","inventory_admin_id":"0","diff_num":"0","is_chayi":"0","inventory_status":"2","inventory_times":"1","created_at":"2022-12-14 16:45:39","updated_at":"2022-12-14 16:45:39","co_val":"灰色","si_val":"L","is_diff_formal":"否","is_chayi_formal":"","inventory_status_formal":"未盘点","inventory_times_formal":"初盘"}]',
            },
            total: { type: "integer", description: "4" },
        },
        additionalProperties: false,
    },
    requestFunctionName: "getInventoryDpDetail",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取盘点单详情↗](http://yapi.yishou.com/project/128/interface/api/34870) 的 **请求函数**
 *
 * @分类 [次品盘点↗](http://yapi.yishou.com/project/128/interface/api/cat_3634)
 * @请求头 `POST /erp/InventoryDp/getInventoryDpDetail`
 */
export const getInventoryDpDetail = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getInventoryDpDetailRequestConfig, requestData), ...args);
};
getInventoryDpDetail.requestConfig = getInventoryDpDetailRequestConfig;
/**
 * 接口 [获取包裹号操作日志↗](http://yapi.yishou.com/project/128/interface/api/34879) 的 **请求配置**
 *
 * @分类 [次品盘点↗](http://yapi.yishou.com/project/128/interface/api/cat_3634)
 * @请求头 `POST /erp/InventoryDp/getInventoryDpOperateLog`
 */
const getInventoryDpOperateLogRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/InventoryDp/getInventoryDpOperateLog",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["inventoryDpId"],
        properties: { inventoryDpId: { type: "string", description: "盘点单id" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            logList: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        id: { type: "string", description: '"14"' },
                        inventory_dp_id: { type: "string", description: '"5"' },
                        operate_type: { type: "string", description: '"6"' },
                        operate_admin: { type: "string", description: '"刘飞鸿"' },
                        created_at: { type: "string", description: '"2022-12-14 16:46:18"' },
                        updated_at: { type: "string", description: '"2022-12-14 16:46:18"' },
                        operate_type_formal: { type: "string", description: '"结束盘点单"' },
                    },
                    additionalProperties: false,
                },
                description: '[{"id":"14","inventory_dp_id":"5","operate_type":"6","operate_admin":"刘飞鸿","created_at":"2022-12-14 16:46:18","updated_at":"2022-12-14 16:46:18","operate_type_formal":"结束盘点单"},{"id":"13","inventory_dp_id":"5","operate_type":"1","operate_admin":"刘飞鸿","created_at":"2022-12-14 16:45:39","updated_at":"2022-12-14 16:45:39","operate_type_formal":"创建盘点单"}]',
            },
        },
        additionalProperties: false,
    },
    requestFunctionName: "getInventoryDpOperateLog",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取包裹号操作日志↗](http://yapi.yishou.com/project/128/interface/api/34879) 的 **请求函数**
 *
 * @分类 [次品盘点↗](http://yapi.yishou.com/project/128/interface/api/cat_3634)
 * @请求头 `POST /erp/InventoryDp/getInventoryDpOperateLog`
 */
export const getInventoryDpOperateLog = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getInventoryDpOperateLogRequestConfig, requestData), ...args);
};
getInventoryDpOperateLog.requestConfig = getInventoryDpOperateLogRequestConfig;
/**
 * 接口 [创建终盘↗](http://yapi.yishou.com/project/128/interface/api/34888) 的 **请求配置**
 *
 * @分类 [次品盘点↗](http://yapi.yishou.com/project/128/interface/api/cat_3634)
 * @请求头 `POST /erp/InventoryDp/createInventoryDpEndInventory`
 */
const createInventoryDpEndInventoryRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/InventoryDp/createInventoryDpEndInventory",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["inventoryDpId"],
        properties: { inventoryDpId: { type: "string", description: "盘点单id" } },
    },
    responseDataJsonSchema: { type: "object" },
    requestFunctionName: "createInventoryDpEndInventory",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [创建终盘↗](http://yapi.yishou.com/project/128/interface/api/34888) 的 **请求函数**
 *
 * @分类 [次品盘点↗](http://yapi.yishou.com/project/128/interface/api/cat_3634)
 * @请求头 `POST /erp/InventoryDp/createInventoryDpEndInventory`
 */
export const createInventoryDpEndInventory = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(createInventoryDpEndInventoryRequestConfig, requestData), ...args);
};
createInventoryDpEndInventory.requestConfig = createInventoryDpEndInventoryRequestConfig;
/**
 * 接口 [结束盘点↗](http://yapi.yishou.com/project/128/interface/api/34897) 的 **请求配置**
 *
 * @分类 [次品盘点↗](http://yapi.yishou.com/project/128/interface/api/cat_3634)
 * @请求头 `POST /erp/InventoryDp/setEndInventoryDpEndInventory`
 */
const setEndInventoryDpEndInventoryRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/InventoryDp/setEndInventoryDpEndInventory",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["inventoryDpId"],
        properties: { inventoryDpId: { type: "string", description: "盘点单id" } },
    },
    responseDataJsonSchema: { type: "object" },
    requestFunctionName: "setEndInventoryDpEndInventory",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [结束盘点↗](http://yapi.yishou.com/project/128/interface/api/34897) 的 **请求函数**
 *
 * @分类 [次品盘点↗](http://yapi.yishou.com/project/128/interface/api/cat_3634)
 * @请求头 `POST /erp/InventoryDp/setEndInventoryDpEndInventory`
 */
export const setEndInventoryDpEndInventory = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(setEndInventoryDpEndInventoryRequestConfig, requestData), ...args);
};
setEndInventoryDpEndInventory.requestConfig = setEndInventoryDpEndInventoryRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/controller/defectiveInventory3634.js